import useSalonTrackingController from '@admin/api/useSalonTrackingController'
import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Grid from '@blocks/Grid'
import Resource from '@components/modules/Resource'
import React, { useState } from 'react'
import TrackingDashboard from './components/Dashboard'
import columns from './config/columns'
import useTrackingForm from './hooks/useTrackingForm'

export default function SalonTrackingPage() {
    const { salon } = useSalonManagerContext()
    const controller = useSalonTrackingController(salon.state.id)
    const Form = useTrackingForm(salon)
    
    const [trackings, setTrackings] = useState<Admin.Resources.Tracking[]>()

    return (
        <Grid>
            <TrackingDashboard trackings={trackings} />
            <Resource
                cache={`admin:salon:${salon.state.id}:trackings`}
                form={Form}
                label="tracking number"
                controller={controller}
                columns={columns}
                onChange={setTrackings}
                heading="Tracking" />
        </Grid>
    )
}